/**
 * @fileoverview Authentication Footer Component
 * 
 * This component displays the footer section for authentication-related pages
 * in the Heidrick & Struggles Leader Profile application. It includes the
 * Navigator logo and important links such as Privacy Notice, Terms of Use,
 * and Contact information.
 */

import React from "react";
import { footerValues } from "./commonFunctions";

/**
 * AuthFooter Component
 * 
 * Renders a consistent footer across authentication pages with branding
 * and legal/support links. The component has two main sections:
 * 1. Left side: Contains the "powered by" text and Navigator logo
 * 2. Right side: Contains navigational links with proper separators
 * 
 * @returns {JSX.Element} The rendered footer component
 */
const AuthFooter = () => {

  return (
    <div className="authFooter">
      {/* Left side with branding */}
      <div className="footerLeftSide">
        {/* <p className="footerText">powered By:</p> */}
        <img 
          src='./../assets/img/HS_Logo_Footer.svg'
          alt="Heidrick & Struggles Logo"
        />
      </div>

      {/* Right side with navigational links */}
      <div className="footerRightSide">
        <div className="authFooterLinks">
          {footerValues()?.map((item, index) => {
            // Determine if this is the last item in the footer links
            const lengthCheck = index + 1 === footerValues()?.length;

            return (
              <div className="footerDiv" key={item?.url}>
                <div
                  className={lengthCheck ? "authFooterPointer" : "authFooterSubtitle"}
                  onClick={item.onClick}
                >
                  {item.url}
                </div>
                {/* Add different divider styles for the last item vs others */}
                {lengthCheck ? <div className="authFooterDividerLast"></div> : <div className="authFooterDivider"></div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AuthFooter;
